// import React, { useRef, useEffect, useState } from "react";
// import {
//   Row,
//   Col,
//   Card,
//   Typography,
//   Select,
//   Button,
//   Pagination,
//   Modal,
//   Input,
//   message,
// } from "antd";
// import LeadCard from "./LeadCard";
// import AdminCard from "./AdminCard";
// import { FilterOutlined } from "@ant-design/icons";
// import { useLocation, useNavigate } from "react-router-dom";
// import { connect, useDispatch } from "react-redux";
// import "./newDashboard.css";
// import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
// import axiosNew from "../../store/api/axiosNew";
// import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
// import { formatAmountIndian } from "./FormatAmount";

// const { TextArea } = Input;

// const MyLeadsBusinessRetailWeb = (props) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { Title } = Typography;
//   const dispatch = useDispatch();
//   const [selectedLead, setSelectedLead] = useState(null);

//   // Modal & Feedback States
//   const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
//   const [feedbackReason, setFeedbackReason] = useState("");
//   const [pendingStatus, setPendingStatus] = useState(null);
//   const [submittingFeedback, setSubmittingFeedback] = useState(false);

//   const [filters, setFilters] = useState({
//     location: null,
//     landType: null,
//     budget: null,
//     plotSize: null,
//   });
//   const filterLeads = location.state?.filters;
//   const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);
//   const rightColRef = useRef(null);
//   const [rightColPos, setRightColPos] = useState({ left: 0, width: 0 });

//   const userName = localStorage.getItem("name");
//   const {
//     allLeads,
//     myRetailLeads,
//     retailPagination,
//     fetchAllLeads,
//     fetchMyRetailLeads,
//     updateLeadStatus,
//     addLeadToCart,
//     removeLeadFromCart,
//   } = useBusinessDashboardApi();

//   // Update right column position
//   useEffect(() => {
//     const updatePosition = () => {
//       if (rightColRef.current) {
//         const rect = rightColRef.current.getBoundingClientRect();
//         setRightColPos({ left: rect.left, width: rect.width });
//       }
//     };
//     updatePosition();
//     window.addEventListener("resize", updatePosition);
//     return () => window.removeEventListener("resize", updatePosition);
//   }, []);

//   const fetchFilteredLeadsFromPage = async (filters) => {
//     try {
//       const accessToken = localStorage.getItem("accessToken");
//       const baseURL = "https://apilead.blaccdot.com/api/admin/all-lead";

//       const params = {};
//       if (filters?.area) params.search = filters.area;
//       if (filters?.landType?.length > 0)
//         params.category = filters.landType.join(",");
//       if (filters?.budget?.length === 2) {
//         params.minBudget = filters.budget[0];
//         params.maxBudget = filters.budget[1];
//       }
//       if (filters?.plotSize?.length > 0)
//         params.plotSize = filters.plotSize.join(",");

//       const res = await axiosNew.get(baseURL, {
//         headers: { Authorization: `Bearer ${accessToken}` },
//         params,
//       });

//       const data = res.data?.data?.leads || [];
//       setFilteredLeadsNav(data);
//     } catch (err) {
//       console.error("Error fetching filtered leads:", err);
//       setFilteredLeadsNav([]);
//     }
//   };

//   useEffect(() => {
//     if (filterLeads) {
//       fetchFilteredLeadsFromPage(filterLeads);
//     }
//   }, [filterLeads]);

//   const apiLeads = Array.isArray(myRetailLeads) ? myRetailLeads : [];

//   const leads = apiLeads.map((lead) => ({
//     id: lead._id,
//     name: lead.name,
//     place: lead.location,
//     price: lead.budget,
//     currentRate: lead.currentRate,
//     landType: lead.subcategory?.label || "",
//     rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
//     status: lead.status || "",
//     user_status: lead.user_status || "",
//     siteVisit: lead.siteVisitDays?.join(", ") || "",
//     lookingFor: lead.property_details || "",
//     contact: lead.phone,
//     type: lead.leadType,
//     category: lead.category,
//     sqft: lead.spaceSqft || 0,
//     state: lead.state || "",
//     district: lead.district || "",
//     area: lead.area || "",
//     pincode: lead.pincode || "",
//     subCategoryId: lead.subcategory?._id,
//     subCategoryLabel: lead.subcategory?.label || "",
//     subCategoryName: lead.subcategory?.name || "",
//     purpose: lead.purpose || "",
//   }));

//   // Priority lead
//   const priorityLead = leads.find((lead) => {
//     const [purchased, total] = (lead.rating || "0/0").split("/").map(Number);
//     return total - purchased === 1;
//   });

//   const adminLead = priorityLead
//     ? priorityLead
//     : leads[Math.floor(Math.random() * leads.length)] || {};

//   const { locationOptions, landTypeOptions, budgetOptions, plotSizeOptions } =
//     useLeadOptions(leads);

//   // Filtered leads
//   const filteredLeads = leads.filter((lead) => {
//     return (
//       (!filters.location ||
//         filters.location.length === 0 ||
//         filters.location.includes(lead.place)) &&
//       (!filters.landType ||
//         filters.landType.length === 0 ||
//         filters.landType.includes(lead.landType)) &&
//       (!filters.budget ||
//         filters.budget.length === 0 ||
//         filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
//       (!filters.plotSize ||
//         filters.plotSize.length === 0 ||
//         filters.plotSize.some((s) => Number(lead.sqft) >= Number(s)))
//     );
//   });

//   const statusOptions = [
//     { label: "Qualified", value: "qualified" },
//     { label: "RNR", value: "rnr" },
//     { label: "Intake", value: "intake" },
//     { label: "Disqualified", value: "disqualified" },
//   ];

//   const handleFilter = () => navigate("/user-dashboard-filter");

//   const handleAddToCart = () => {
//     navigate("/my-cart");
//   };

//   const leadsByStatus = React.useMemo(() => {
//     return {
//       qualified: leads.filter((l) => l.user_status === "qualified"),
//       rnr: leads.filter((l) => l.user_status === "rnr"),
//       intake: leads.filter((l) => l.user_status === "intake"),
//       disqualified: leads.filter((l) => l.user_status === "disqualified"),
//     };
//   }, [leads]);

//   const leadsToRender =
//     filteredLeadsNav.length > 0 ? filteredLeadsNav : filteredLeads;

//   const finalLeads = React.useMemo(() => {
//     return leadsToRender.filter((lead) => lead.purpose === "BUILD");
//   }, [leadsToRender]);

//   // Status Change Logic
//   const handleStatusChange = (selectedValue) => {
//     if (!selectedLead) return;

//     if (selectedValue === "disqualified") {
//       setPendingStatus(selectedValue);
//       setIsFeedbackModalOpen(true);
//     } else {
//       applyStatusUpdate(selectedValue);
//     }
//   };

//   const applyStatusUpdate = (status) => {
//     updateLeadStatus(selectedLead.id, status);
//     setSelectedLead((prev) => ({
//       ...prev,
//       user_status: status,
//     }));
//   };

//   // Submit Disqualification Feedback
//   const handleFeedbackSubmit = async () => {
//     if (!feedbackReason.trim()) {
//       message.error("Please enter a reason for disqualification.");
//       return;
//     }

//     try {
//       setSubmittingFeedback(true);
//       const accessToken = localStorage.getItem("accessToken");

//       await axiosNew.post(
//         "/admin/feedback",
//         {
//           leadId: selectedLead.id,
//           reason: feedbackReason,
//           status: pendingStatus,
//         },
//         {
//           headers: { Authorization: `Bearer ${accessToken}` },
//         },
//       );

//       message.success("Feedback submitted successfully");

//       // Update lead status after successfully submitting feedback
//       applyStatusUpdate(pendingStatus);

//       // Reset modal states
//       setIsFeedbackModalOpen(false);
//       setFeedbackReason("");
//       setPendingStatus(null);
//     } catch (error) {
//       console.error("Error submitting feedback:", error);
//       message.error("Failed to submit feedback. Please try again.");
//     } finally {
//       setSubmittingFeedback(false);
//     }
//   };

//   const handleModalCancel = () => {
//     setIsFeedbackModalOpen(false);
//     setFeedbackReason("");
//     setPendingStatus(null);
//   };

//   return (
//     <div style={{ padding: "4px", fontSize: "13px" }}>
//       {/* Page Title & Filters */}
//       <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
//         <Col
//           span={6}
//           style={{ display: "flex", justifyContent: "space-between" }}
//         >
//           <Title level={4}>My Retail Leads </Title>
//         </Col>
//       </Row>

//       {/* Leads & Admin Card */}
//       <Row gutter={20}>
//         <Col span={6}>
//           {leadsToRender.map((lead) => {
//             return (
//               <LeadCard
//                 key={`lead-${lead.id}`}
//                 {...lead}
//                 showCartIcon={false}
//                 onClick={() => setSelectedLead({ ...lead })}
//                 isSelected={selectedLead?.id === lead.id}
//               />
//             );
//           })}

//           <Pagination
//             simple
//             showSizeChanger={false}
//             current={retailPagination.currentPage}
//             total={retailPagination.total || 10}
//             pageSize={retailPagination.perPage}
//             onChange={(page) => fetchMyRetailLeads(page)}
//           />
//         </Col>

//         <Col flex="2px">
//           <div
//             style={{ width: 2, backgroundColor: "#DBEAFF", height: "100%" }}
//           />
//         </Col>

//         <Col span={17} ref={rightColRef}>
//           {selectedLead ? (
//             <>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   marginBottom: 12,
//                 }}
//               >
//                 <Typography.Title level={4} style={{ margin: 0 }}>
//                   Lead Details
//                 </Typography.Title>
//                 <Select
//                   placeholder="Update Lead Status"
//                   value={selectedLead?.user_status?.toLowerCase()}
//                   style={{ width: 220 }}
//                   options={statusOptions}
//                   onChange={handleStatusChange}
//                 />
//               </div>

//               <Card
//                 style={{
//                   borderRadius: 6,
//                   background: "#fafafa",
//                   marginBottom: 12,
//                 }}
//               >
//                 <Row gutter={0}>
//                   <Col span={6} className="search-select-divider col-padding">
//                     <strong>Name</strong>
//                     <p>{selectedLead.name}</p>
//                   </Col>
//                   <Col span={6} className="search-select-divider col-padding">
//                     <strong>Contact No.</strong>
//                     <p>{selectedLead.contact}</p>
//                   </Col>
//                   <Col span={6} className="search-select-divider col-padding">
//                     <strong>Client Location</strong>
//                     <p>{selectedLead.place}</p>
//                   </Col>
//                   <Col span={6} className="col-padding">
//                     <strong>Sq.ft</strong>
//                     <p>{selectedLead.sqft}</p>
//                   </Col>
//                 </Row>
//                 <Row gutter={0} style={{ marginTop: 10 }}>
//                   <Col span={6} className="search-select-divider col-padding">
//                     <strong>Budget</strong>
//                     <p>₹ {formatAmountIndian(selectedLead.price)}</p>
//                   </Col>
//                   <Col span={6} className="search-select-divider col-padding">
//                     <strong>Preferred location</strong>
//                     <p>
//                       {selectedLead?.state || ""}-{selectedLead?.district || ""}
//                       -{selectedLead?.area || ""}--
//                       {selectedLead?.pincode || ""}
//                     </p>
//                   </Col>
//                   <Col span={6} className="search-select-divider col-padding">
//                     <strong>Site Visit</strong>
//                     <p>{selectedLead.siteVisit}</p>
//                   </Col>

//                   <Col span={6} className="col-padding">
//                     <strong>Looking For</strong>
//                     <p>{selectedLead.lookingFor}</p>
//                   </Col>
//                 </Row>
//               </Card>
//             </>
//           ) : (
//             <AdminCard
//               {...adminLead}
//               onTopPickClick={(leadId) =>
//                 navigate(`/user-dashboard?selectedleadid=${leadId}`)
//               }
//             />
//           )}

//           <div
//             className="thin-scroll"
//             style={{
//               display: "flex",
//               gap: "8px",
//               overflowX: "auto",
//             }}
//           >
//             {statusOptions.map(({ label, value }) => {
//               const leads = leadsByStatus[value] || [];

//               return (
//                 <div
//                   key={value}
//                   className="thin-scroll"
//                   style={{
//                     minWidth: 270,
//                     maxHeight: 360,
//                     padding: "0 8px 8px",
//                     background: "#f9fafb",
//                     border: "1px solid #e5e7eb",
//                     borderRadius: 6,
//                     overflowY: "auto",
//                   }}
//                 >
//                   <h5
//                     style={{
//                       margin: 0,
//                       marginBottom: 2,
//                       position: "sticky",
//                       top: 0,
//                       background: "#f9fafb",
//                       zIndex: 2,
//                       padding: "16px 8px 8px",
//                       borderBottom: "1px solid #e5e7eb",
//                       fontSize: 14,
//                     }}
//                   >
//                     {label} ({leads.length})
//                   </h5>

//                   {leads.length === 0 ? (
//                     <Typography.Text type="secondary">
//                       No leads available
//                     </Typography.Text>
//                   ) : (
//                     leads.map((lead) => (
//                       <LeadCard
//                         key={lead.id}
//                         {...lead}
//                         showCheckbox={false}
//                         showCartIcon={false}
//                         onClick={() => setSelectedLead(lead)}
//                         isSelected={selectedLead?.id === lead.id}
//                       />
//                     ))
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         </Col>
//       </Row>

//       {/* Disqualification Feedback Modal */}
//       <Modal
//         title="Disqualification Feedback"
//         open={isFeedbackModalOpen}
//         onCancel={handleModalCancel}
//         footer={[
//           <Button key="cancel" onClick={handleModalCancel}>
//             Cancel
//           </Button>,
//           <Button
//             key="submit"
//             type="primary"
//             loading={submittingFeedback}
//             onClick={handleFeedbackSubmit}
//           >
//             Submit
//           </Button>,
//         ]}
//       >
//         <p style={{ marginBottom: 12 }}>
//           Please provide a reason or feedback for marking this lead as
//           disqualified:
//         </p>
//         <TextArea
//           rows={4}
//           placeholder="Enter reason or feedback..."
//           value={feedbackReason}
//           onChange={(e) => setFeedbackReason(e.target.value)}
//         />
//       </Modal>
//     </div>
//   );
// };

// export default MyLeadsBusinessRetailWeb;
import React, { useRef, useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Select,
  Button,
  Pagination,
  Modal,
  Input,
  message,
} from "antd";
import LeadCard from "./LeadCard";
import AdminCard from "./AdminCard";
import { FilterOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import "./newDashboard.css";
import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
import axiosNew from "../../store/api/axiosNew";
import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
import { formatAmountIndian } from "./FormatAmount";

const { TextArea } = Input;

const MyLeadsBusinessRetailWeb = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { Title } = Typography;
  const dispatch = useDispatch();
  const [selectedLead, setSelectedLead] = useState(null);

  // Modal & Feedback States
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [feedbackReason, setFeedbackReason] = useState("");
  const [pendingStatus, setPendingStatus] = useState(null);
  const [submittingFeedback, setSubmittingFeedback] = useState(false);

  const [filters, setFilters] = useState({
    location: null,
    landType: null,
    budget: null,
    plotSize: null,
  });
  const filterLeads = location.state?.filters;
  const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);
  const rightColRef = useRef(null);
  const [rightColPos, setRightColPos] = useState({ left: 0, width: 0 });

  const userName = localStorage.getItem("name");
  const {
    allLeads,
    myRetailLeads,
    retailPagination,
    fetchAllLeads,
    fetchMyRetailLeads,
    updateLeadStatus,
    addLeadToCart,
    removeLeadFromCart,
  } = useBusinessDashboardApi();

  // Update right column position
  useEffect(() => {
    const updatePosition = () => {
      if (rightColRef.current) {
        const rect = rightColRef.current.getBoundingClientRect();
        setRightColPos({ left: rect.left, width: rect.width });
      }
    };
    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  const fetchFilteredLeadsFromPage = async (filters) => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const baseURL = "https://apilead.blaccdot.com/api/admin/all-lead";

      const params = {};
      if (filters?.area) params.search = filters.area;
      if (filters?.landType?.length > 0)
        params.category = filters.landType.join(",");
      if (filters?.budget?.length === 2) {
        params.minBudget = filters.budget[0];
        params.maxBudget = filters.budget[1];
      }
      if (filters?.plotSize?.length > 0)
        params.plotSize = filters.plotSize.join(",");

      const res = await axiosNew.get(baseURL, {
        headers: { Authorization: `Bearer ${accessToken}` },
        params,
      });

      const data = res.data?.data?.leads || [];
      setFilteredLeadsNav(data);
    } catch (err) {
      console.error("Error fetching filtered leads:", err);
      setFilteredLeadsNav([]);
    }
  };

  useEffect(() => {
    if (filterLeads) {
      fetchFilteredLeadsFromPage(filterLeads);
    }
  }, [filterLeads]);

  const apiLeads = Array.isArray(myRetailLeads) ? myRetailLeads : [];

  const leads = apiLeads.map((lead) => ({
    id: lead._id,
    name: lead.name,
    place: lead.location,
    price: lead.budget,
    currentRate: lead.currentRate,
    landType: lead.subcategory?.label || "",
    rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
    status: lead.status || "",
    user_status: lead.user_status || "",
    siteVisit: lead.siteVisitDays?.join(", ") || "",
    lookingFor: lead.property_details || "",
    contact: lead.phone,
    type: lead.leadType,
    category: lead.category,
    sqft: lead.spaceSqft || 0,
    state: lead.state || "",
    district: lead.district || "",
    area: lead.area || "",
    pincode: lead.pincode || "",
    subCategoryId: lead.subcategory?._id,
    subCategoryLabel: lead.subcategory?.label || "",
    subCategoryName: lead.subcategory?.name || "",
    purpose: lead.purpose || "",
  }));

  // Priority lead
  const priorityLead = leads.find((lead) => {
    const [purchased, total] = (lead.rating || "0/0").split("/").map(Number);
    return total - purchased === 1;
  });

  const adminLead = priorityLead
    ? priorityLead
    : leads[Math.floor(Math.random() * leads.length)] || {};

  const { locationOptions, landTypeOptions, budgetOptions, plotSizeOptions } =
    useLeadOptions(leads);

  // Filtered leads
  const filteredLeads = leads.filter((lead) => {
    return (
      (!filters.location ||
        filters.location.length === 0 ||
        filters.location.includes(lead.place)) &&
      (!filters.landType ||
        filters.landType.length === 0 ||
        filters.landType.includes(lead.landType)) &&
      (!filters.budget ||
        filters.budget.length === 0 ||
        filters.budget.some((b) => Number(lead.price) <= Number(b))) &&
      (!filters.plotSize ||
        filters.plotSize.length === 0 ||
        filters.plotSize.some((s) => Number(lead.sqft) >= Number(s)))
    );
  });

  const statusOptions = [
    { label: "Qualified", value: "qualified" },
    { label: "RNR", value: "rnr" },
    { label: "Intake", value: "intake" },
    { label: "Disqualified", value: "disqualified" },
  ];

  const handleFilter = () => navigate("/user-dashboard-filter");

  const handleAddToCart = () => {
    navigate("/my-cart");
  };

  const leadsByStatus = React.useMemo(() => {
    return {
      qualified: leads.filter((l) => l.user_status === "qualified"),
      rnr: leads.filter((l) => l.user_status === "rnr"),
      intake: leads.filter((l) => l.user_status === "intake"),
      disqualified: leads.filter((l) => l.user_status === "disqualified"),
    };
  }, [leads]);

  const leadsToRender =
    filteredLeadsNav.length > 0 ? filteredLeadsNav : filteredLeads;

  const finalLeads = React.useMemo(() => {
    return leadsToRender.filter((lead) => lead.purpose === "BUILD");
  }, [leadsToRender]);

  // Status Change Logic
  const handleStatusChange = (selectedValue) => {
    if (!selectedLead) return;

    if (selectedValue === "disqualified") {
      setPendingStatus(selectedValue);
      setIsFeedbackModalOpen(true);
    } else {
      applyStatusUpdate(selectedValue);
    }
  };

  const applyStatusUpdate = async (status, extraData = {}) => {
    try {
      const extraPayload =
        typeof extraData === "string"
          ? { disqualifiedReason: extraData }
          : extraData;

      // Don't put user_status here — updateLeadStatus adds it itself now.
      await updateLeadStatus(selectedLead.id, status, extraPayload);

      setSelectedLead((prev) => ({
        ...prev,
        user_status: status,
      }));
    } catch (err) {
      console.error("Failed to update status:", err);
      throw err; // <-- rethrow so handleFeedbackSubmit's catch actually fires
    }
  };

  // Submit Disqualification Feedback
  const handleFeedbackSubmit = async () => {
    if (!feedbackReason.trim()) {
      message.error("Please enter a reason for disqualification.");
      return;
    }

    try {
      setSubmittingFeedback(true);

      await applyStatusUpdate(pendingStatus, {
        disqualifiedReason: feedbackReason,
      });

      message.success("Lead marked as disqualified successfully");

      // Reset modal states
      setIsFeedbackModalOpen(false);
      setFeedbackReason("");
      setPendingStatus(null);
    } catch (error) {
      console.error("Error submitting feedback:", error);
      message.error("Failed to submit feedback. Please try again.");
    } finally {
      setSubmittingFeedback(false);
    }
  };

  const handleModalCancel = () => {
    setIsFeedbackModalOpen(false);
    setFeedbackReason("");
    setPendingStatus(null);
  };

  return (
    <div style={{ padding: "4px", fontSize: "13px" }}>
      {/* Page Title & Filters */}
      <Row gutter={16} align="middle" style={{ marginBottom: "16px" }}>
        <Col
          span={6}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Title level={4}>My Retail Leads </Title>
        </Col>
      </Row>

      {/* Leads & Admin Card */}
      <Row gutter={20}>
        <Col span={6}>
          {leadsToRender.map((lead) => {
            return (
              <LeadCard
                key={`lead-${lead.id}`}
                {...lead}
                showCartIcon={false}
                onClick={() => setSelectedLead({ ...lead })}
                isSelected={selectedLead?.id === lead.id}
              />
            );
          })}

          <Pagination
            simple
            showSizeChanger={false}
            current={retailPagination.currentPage}
            total={retailPagination.total || 10}
            pageSize={retailPagination.perPage}
            onChange={(page) => fetchMyRetailLeads(page)}
          />
        </Col>

        <Col flex="2px">
          <div
            style={{ width: 2, backgroundColor: "#DBEAFF", height: "100%" }}
          />
        </Col>

        <Col span={17} ref={rightColRef}>
          {selectedLead ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 12,
                }}
              >
                <Typography.Title level={4} style={{ margin: 0 }}>
                  Lead Details
                </Typography.Title>
                <Select
                  placeholder="Update Lead Status"
                  value={selectedLead?.user_status?.toLowerCase()}
                  style={{ width: 220 }}
                  options={statusOptions}
                  onChange={handleStatusChange}
                />
              </div>

              <Card
                style={{
                  borderRadius: 6,
                  background: "#fafafa",
                  marginBottom: 12,
                }}
              >
                <Row gutter={0}>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Name</strong>
                    <p>{selectedLead.name}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Contact No.</strong>
                    <p>{selectedLead.contact}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Client Location</strong>
                    <p>{selectedLead.place}</p>
                  </Col>
                  <Col span={6} className="col-padding">
                    <strong>Sq.ft</strong>
                    <p>{selectedLead.sqft}</p>
                  </Col>
                </Row>
                <Row gutter={0} style={{ marginTop: 10 }}>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Budget</strong>
                    <p>₹ {formatAmountIndian(selectedLead.price)}</p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Preferred location</strong>
                    <p>
                      {selectedLead?.state || ""}-{selectedLead?.district || ""}
                      -{selectedLead?.area || ""}--
                      {selectedLead?.pincode || ""}
                    </p>
                  </Col>
                  <Col span={6} className="search-select-divider col-padding">
                    <strong>Site Visit</strong>
                    <p>{selectedLead.siteVisit}</p>
                  </Col>

                  <Col span={6} className="col-padding">
                    <strong>Looking For</strong>
                    <p>{selectedLead.lookingFor}</p>
                  </Col>
                </Row>
              </Card>
            </>
          ) : (
            <AdminCard
              {...adminLead}
              onTopPickClick={(leadId) =>
                navigate(`/user-dashboard?selectedleadid=${leadId}`)
              }
            />
          )}

          <div
            className="thin-scroll"
            style={{
              display: "flex",
              gap: "8px",
              overflowX: "auto",
            }}
          >
            {statusOptions.map(({ label, value }) => {
              const leads = leadsByStatus[value] || [];

              return (
                <div
                  key={value}
                  className="thin-scroll"
                  style={{
                    minWidth: 270,
                    maxHeight: 360,
                    padding: "0 8px 8px",
                    background: "#f9fafb",
                    border: "1px solid #e5e7eb",
                    borderRadius: 6,
                    overflowY: "auto",
                  }}
                >
                  <h5
                    style={{
                      margin: 0,
                      marginBottom: 2,
                      position: "sticky",
                      top: 0,
                      background: "#f9fafb",
                      zIndex: 2,
                      padding: "16px 8px 8px",
                      borderBottom: "1px solid #e5e7eb",
                      fontSize: 14,
                    }}
                  >
                    {label} ({leads.length})
                  </h5>

                  {leads.length === 0 ? (
                    <Typography.Text type="secondary">
                      No leads available
                    </Typography.Text>
                  ) : (
                    leads.map((lead) => (
                      <LeadCard
                        key={lead.id}
                        {...lead}
                        showCheckbox={false}
                        showCartIcon={false}
                        onClick={() => setSelectedLead(lead)}
                        isSelected={selectedLead?.id === lead.id}
                      />
                    ))
                  )}
                </div>
              );
            })}
          </div>
        </Col>
      </Row>

      {/* Disqualification Feedback Modal */}
      <Modal
        title="Disqualification Feedback"
        open={isFeedbackModalOpen}
        onCancel={handleModalCancel}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={submittingFeedback}
            onClick={handleFeedbackSubmit}
          >
            Submit
          </Button>,
        ]}
      >
        <p style={{ marginBottom: 12 }}>
          Please provide a reason or feedback for marking this lead as
          disqualified:
        </p>
        <TextArea
          rows={4}
          placeholder="Enter reason or feedback..."
          value={feedbackReason}
          onChange={(e) => setFeedbackReason(e.target.value)}
        />
      </Modal>
    </div>
  );
};

export default MyLeadsBusinessRetailWeb;
